import type { NodeData } from '../types/flow-types';

export type NoteColor = 'orange' | 'blue' | 'red' | 'yellow' | 'pink';

export interface NoteTheme {
	id: NoteColor;
	label: string;
	background: string;
	header: string;
	text: string;
	mutedText: string;
	border: string;
	accent: string;
}

export const NOTE_THEMES: NoteTheme[] = [
	{
		id: 'orange',
		label: 'Orange',
		background: '#fed7aa',
		header: '#fdba74',
		text: '#7c2d12',
		mutedText: '#9a3412',
		border: '#fb923c',
		accent: '#f97316',
	},
	{
		id: 'blue',
		label: 'Blue',
		background: '#bfdbfe',
		header: '#93c5fd',
		text: '#1e3a8a',
		mutedText: '#1d4ed8',
		border: '#60a5fa',
		accent: '#3b82f6',
	},
	{
		id: 'red',
		label: 'Red',
		background: '#fecaca',
		header: '#fca5a5',
		text: '#7f1d1d',
		mutedText: '#991b1b',
		border: '#f87171',
		accent: '#ef4444',
	},
	{
		id: 'yellow',
		label: 'Yellow',
		background: '#fef08a',
		header: '#fde047',
		text: '#713f12',
		mutedText: '#854d0e',
		border: '#facc15',
		accent: '#eab308',
	},
	{
		id: 'pink',
		label: 'Pink',
		background: '#fbcfe8',
		header: '#f9a8d4',
		text: '#831843',
		mutedText: '#9d174d',
		border: '#f472b6',
		accent: '#ec4899',
	},
];

export const DEFAULT_NOTE_THEME = NOTE_THEMES[0];

export function resolveNoteTheme(data: NodeData | Record<string, unknown>): NoteTheme {
	const noteColor = String(data.noteColor ?? '').toLowerCase();
	return (
		NOTE_THEMES.find((theme) => theme.id === noteColor) ??
		NOTE_THEMES.find(
			(theme) => theme.accent.toLowerCase() === String(data.color ?? '').toLowerCase(),
		) ??
		DEFAULT_NOTE_THEME
	);
}
